// Modern tag chip: muted bg + colored dot + neutral label.
// Avoids the "rainbow border" web-1.0 look.
import React from 'react';

export const TAG_PALETTE = [
  { name: 'Indigo',  value: '#4338ca' },
  { name: 'Blue',    value: '#2563eb' },
  { name: 'Sky',     value: '#0284c7' },
  { name: 'Cyan',    value: '#0891b2' },
  { name: 'Teal',    value: '#0d9488' },
  { name: 'Emerald', value: '#059669' },
  { name: 'Lime',    value: '#65a30d' },
  { name: 'Amber',   value: '#d97706' },
  { name: 'Orange',  value: '#ea580c' },
  { name: 'Rose',    value: '#e11d48' },
  { name: 'Pink',    value: '#db2777' },
  { name: 'Violet',  value: '#7c3aed' },
  { name: 'Slate',   value: '#475569' },
];

export default function TagPill({ tag, size = 'sm', onRemove }) {
  const px = size === 'lg' ? 'px-3 py-1 text-sm' : 'px-2.5 py-0.5 text-xs';
  const dot = size === 'lg' ? 'w-2.5 h-2.5' : 'w-1.5 h-1.5';
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full bg-slate-100 text-slate-700 ${px} font-medium`}>
      <span className={`${dot} rounded-full`} style={{ background: tag.color || '#475569' }} />
      <span className="truncate max-w-[14rem]">{tag.name}</span>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="ml-0.5 rounded-full hover:bg-slate-200 w-4 h-4 inline-flex items-center justify-center text-slate-500 hover:text-slate-700"
          title="Remove"
        >×</button>
      )}
    </span>
  );
}
